import { Box, Typography } from '@mui/material';

const HeadingSection = ({ heading, icon }) => {
    const Icon = icon.type;
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    background: 'linear-gradient(to right, rgba(24,26,29, 0.8), rgba(18,19,21, 0.8));',
                    padding: 2,
                    borderRadius: 3,
                    width: '100%'
                }}
            >
                <Icon />
                <Typography variant="h3">{heading}</Typography>
            </Box>
        </Box>
    );
};

export default HeadingSection;
